import React from 'react';
import styled, { css } from 'styled-components';

const variants = {
  light: css`
    color: ${props => props.theme.colors.text};
    background: ${props => props.theme.colors.background};
    
    &:hover {
      background: ${props => props.theme.colors.brand};
      color: ${props => props.theme.colors.text};
    }
  `,
  dark: css`
    color: ${props => props.theme.colors.dark.text};
    background: none;
    
    &:hover {
      background: ${props => props.theme.colors.brand};
      color: ${props => props.theme.colors.text};
    }
  `,
  transparent: css`
    color: ${props => props.theme.colors.textLight};
    background: none;
    
    &:hover {
      color: ${props => props.theme.colors.text};
      background: ${props => props.theme.colors.backgroundAlt};
    }
  `
};

const positions = {
  topRight: css`
    position: absolute;
    top: ${props => props.theme.spacing.lg};
    right: ${props => props.theme.spacing.lg};
  `,
  topRightSticky: css`
    position: sticky;
    top: ${props => props.theme.spacing.md};
    left: 100%;
    margin-bottom: -2.5rem;
  `,
  custom: css`` // Allows for custom positioning via style prop
};

const StyledButton = styled.button`
  border: none;
  cursor: pointer;
  width: 2.5rem;
  height: 2.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all ${props => props.theme.transitions.default};
  font-size: 2rem;
  z-index: 2;
  
  ${props => variants[props.$variant]}
  ${props => positions[props.$position]}
  
  &:hover {
    transform: ${props => props.$rotate ? 'rotate(90deg)' : 'none'};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px ${props => props.theme.colors.brand};
  }
`;

const CloseButton = ({ 
  onClick, 
  variant = 'light',
  position = 'topRight',
  rotate = false,
  className,
  style,
  ...props 
}) => {
  return (
    <StyledButton
      onClick={onClick}
      $variant={variant}
      $position={position}
      $rotate={rotate}
      className={className}
      style={style}
      type="button"
      aria-label="Close"
      {...props}
    >
      &times;
    </StyledButton>
  );
};

export default CloseButton; 